
function initAgeVerification() {

    if (Cookies.get('AgeVarified') === 'true') {
        document.body.classList.add('varified-age');
        return;
    }

    const containers = document.querySelectorAll('#ProductGridContainer, .collection-product-grid__container');
    if (!containers.length) return;

    containers.forEach(container => {
        container.addEventListener('click', function (e) {
            const trigger = e.target.closest('.popup-age-trigger');
            if (trigger) {
                const parent = trigger.parentNode;
                parent.classList.add('active');
            }

            const confirmBtn = e.target.closest('.age-confirmation__button');
            if (confirmBtn) {
                Cookies.set('AgeVarified', 'true', { expires: 1 });
                document.body.classList.add('varified-age');
            }
        });
    });
}

initAgeVerification();

function initJudgemeScoreReposition() {

    const container = document.getElementById('judgeme_product_reviews');
    if (!container) return;

    function relocate() {
        const score = container.querySelector('.jm-review-widget-header__average-rating-display');
        const target = container.querySelector('.jm-review-widget-header__main-content');
        if (score && target && target.firstElementChild !== score) {
            target.prepend(score);
        }

        const cluster = container.querySelector('.jm-average-rating-display > .jm-cluster');
        if (!cluster) return;

        // Tag the value/count text nodes with stable classes on first pass, since inserting the
        // stars row between them would otherwise shift their child position on every re-run.
        let value = cluster.querySelector('.jm-average-rating-display__value');
        let count = cluster.querySelector('.jm-average-rating-display__count');
        if (!value || !count) {
            const texts = cluster.querySelectorAll(':scope > .jm-text');
            if (texts.length < 2) return;
            texts[0].classList.add('jm-average-rating-display__value');
            texts[1].classList.add('jm-average-rating-display__count');
            value = texts[0];
            count = texts[1];
        }

        if (!cluster.querySelector('.jm-average-rating-display__stars')) {
            const rating = Math.max(0, Math.min(5, Math.round(parseFloat(value.textContent))));
            const stars = document.createElement('div');
            stars.className = 'jm-star-rating jm-average-rating-display__stars';
            stars.setAttribute('aria-label', rating + ' out of 5 stars');
            for (let i = 0; i < 5; i++) {
                const icon = document.createElement('span');
                icon.className = 'jm-star-rating__font-icon';
                icon.textContent = i < rating ? '' : '';
                stars.appendChild(icon);
            }
            cluster.insertBefore(stars, count);
        }

        if (!count.textContent.trim().toLowerCase().startsWith('based on')) {
            count.textContent = 'based on ' + count.textContent.trim();
        }
    }

    relocate();
    new MutationObserver(relocate).observe(container, { childList: true, subtree: true });
}

initJudgemeScoreReposition();
